<p-panel 
  header="Audit Log" 
  toggler="header"
  [toggleable]="true" 
  [(collapsed)]="collapsed" 
  (onAfterToggle)="expandPanel($event.collapsed)"
  >
  <ng-template #icons>
    @if (!collapsed) {
      <p-button
        severity="secondary"
        label="Refresh"
        size="small"
        aria-label="Refresh table"
        icon="pi pi-refresh"
        [loading]="isLoading"
        (click)="loadData($event)"
      />
    }
  </ng-template>
  <ng-template #headericons let-collapsed>
    <i class="pi pi-chevron-right duration-150" [class]="{ 'rotate-90': !collapsed }"></i>
  </ng-template>

  <p-table
    aria-label="Audit Log table"
    class="table-parameters table-paginator"
    [alwaysShowPaginator]="false"
    [value]="data"
    [columns]="columns"
    [paginator]="true"
    [sortOrder]="defaultSortOrder"
    [sortField]="defaultSortField"
    [totalRecords]="totalRecords"
    [rows]="10"
    [loading]="isLoading"
  >
    <ng-template pTemplate="header" let-columns>
      <tr>
        @for (col of columns; track col) {
          <th [pSortableColumn]="col.field">
            <div class="flex items-center gap-2">
              {{ col.header }}
              <p-sortIcon
                [field]="col.field"
                aria-label="Activate to sort"
                ariaLabelDesc="Activate to sort in descending order"
                ariaLabelAsc="Activate to sort in ascending order"
              />
            </div>
          </th>
        }
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage" let-columns>
      <tr>
        <td [attr.colspan]="columns.length">
          <p class="my-2">No record found</p>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-item>
      <tr>
        <td>{{ item.createdDateTime | utcToLocal }}</td>
        <td>{{ item.appDisplayName }}</td>
        <td>{{ item.loginStatus }}</td>
      </tr>
    </ng-template>
  </p-table>
</p-panel>
